import React, { useState } from 'react';
import { useAuth } from '../../AuthContext';
import './../../App.css';
import './LoginStyles.css';
import { Link, useNavigate } from 'react-router-dom';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { login } = useAuth(); // Use the login function from useAuth
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiUrl}/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });

            if (response.ok) {
                const data = await response.json();
                if (rememberMe) {
                    localStorage.setItem('loggedIn', 'true');
                    localStorage.setItem('firstName', data.firstName);
                    localStorage.setItem('lastName', data.lastName);
                    localStorage.setItem('email', data.email);  // Store email in localStorage
                    // Update the global state with the user's name and email
                    login(data.firstName, data.lastName, data.email);
                }

                alert('Logged in successfully!');
                navigate('/');
            } else {
                const errorData = await response.json();
                setErrorMessage(errorData.message || 'Failed to log in');
            }
        } catch (error) {
            console.error('Login error:', error);
            setErrorMessage('Failed to log in');
        }
    };

    return (
        <div className='login-page template d-flex justify-content-center align-items-center vh-100 bg-secondary'>
            <div className='form_container p-5 rounded bg-white'>
                <form onSubmit={handleSubmit}>
                    <h3 className='text-center'>Log In</h3>
                    <div className='mb-2'>
                        <label htmlFor='email'>Email</label>
                        <input type='email' placeholder='Enter Email' className='form-control' value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor='password'>Password</label>
                        <input type='password' placeholder='Enter Password' className='form-control' value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div className='mb-2 form-check'>
                        <input type='checkbox' className='form-check-input' id='check' checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
                        <label htmlFor='check' className='form-check-label'>
                            Remember me
                        </label>
                    </div>
                    {errorMessage && <p className="text-danger">{errorMessage}</p>}
                    <div className='d-grid'>
                        <button className='btn btn-success'>Sign In</button>
                    </div>
                    <p className='text-end mt-2'>
                        <Link to="/forgot-password">Forgot Password?</Link>
                        <Link to="/signup" className='ms-2'>Sign Up</Link>
                    </p>
                </form>
            </div>
        </div>
    )
}

export default Login;